export default "__VITE_PUBLIC_ASSET__0df28119__"